import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InternalUiContext = /*#__PURE__*/createContext(false);
export function useIsInternalUi() {
  return useContext(InternalUiContext);
}
export function InternalUiProvider({
  children
}) {
  return /*#__PURE__*/_jsx(InternalUiContext.Provider, {
    value: true,
    children: children
  });
}